import type { Analytics, ApiResponse, VerificationAnalytics } from '../../types/ApiTypes';
import { apiManager } from '../api/ApiManager';

export class AnalyticsService {
  async getAnalytics(): Promise<ApiResponse<Analytics>> {
    return apiManager.get<Analytics>('/api/v1/admin/analytics');
  }

  async getVerificationAnalytics(params?: { startDate?: string; endDate?: string }): Promise<ApiResponse<VerificationAnalytics>> {
    return apiManager.get<VerificationAnalytics>('/api/v1/admin/analytics/verification', params as Record<string, unknown>);
  }
}

export const analyticsService = new AnalyticsService();